import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { eraseCookie, getCookie } from "../../utils/cookies";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const $axios = axios.create({
  baseURL: API_BASE_URL,
});

$axios.interceptors.request.use(
  async (config) => {
    const access_token = getCookie("LuxMartClientAccessToken");

    if (access_token && access_token.trim() !== "") {
      config.headers.Authorization = `Token ${access_token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

$axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (
    error: AxiosError & {
      config: InternalAxiosRequestConfig & { _retry?: boolean };
    },
  ) => {
    const pathname = window.location.pathname;
    const langMatch = pathname.match(/^\/(az|en|es|de)(\/|$)/);
    const lang = langMatch ? langMatch[1] : "az";
    const isAuthPath = /^\/(az|en|es|de)?\/?auth/.test(pathname);

    if (error.response?.status === 401 && !isAuthPath) {
      eraseCookie("LuxMartClientAccessToken");
      window.location.href = `/${lang}/auth/login`;
    }

    return Promise.reject(error);
  },
);

export default $axios;
